import React from 'react';
import PropTypes from 'prop-types';

const LanguageItem = ({ text, image, index, active, handleClick }) =>
  <li
    className={`language-selector-item ${active ? 'active' : ''}`}
    onClick={() => handleClick(index)}
  >
    <img src={image} className="icon" role="presentation" />
    <span className="text">{text}</span>
  </li>;

LanguageItem.propTypes = {
  text: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired
};

const lockTypes = [
  { text: 'Web', image: 'https://cdn.auth0.com/website/playground/platforms/lock-web-icon2.svg' },
  { text: 'iOS', image: 'https://cdn.auth0.com/website/playground/platforms/lock-ios-icon.svg' },
  { text: 'Android', image: 'https://cdn.auth0.com/website/playground/platforms/lock-android-icon.svg' }
];

const LanguageSelector = ({ selectedLanguageIndex, handleItemClick }) =>
  <div className="language-selector">
    <div className="container">
      <ul className="language-selector-list">
        { lockTypes.map((type, index) =>
          <LanguageItem
            key={type.text}
            text={type.text}
            image={type.image}
            index={index}
            active={index === selectedLanguageIndex}
            handleClick={handleItemClick}
          />
        )}
      </ul>
    </div>
  </div>;

LanguageSelector.propTypes = {
  selectedLanguageIndex: PropTypes.number.isRequired,
  handleItemClick: PropTypes.func.isRequired
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/components/LanguageSelector/LanguageSelector.js


// WEBPACK FOOTER //
// webpack:///src/components/LanguageSelector/LanguageSelector.js